export default __webpack_public_path__ + "static/mlwassist-icon-9fe17853114482202710a2846f9eb4ac.png";